const backendUrl = process.env.REACT_APP_API_URL!;

export { backendUrl };
